/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResetUserPasswordRequestDto } from '../../models/reset-user-password-request-dto';
import { ResetUserPasswordResponseDto } from '../../models/reset-user-password-response-dto';

export interface ApiAuthResetUserPasswordPost$Params {
    /**
     * oggetto contenente l'username della password da resettare
     */
    body: ResetUserPasswordRequestDto;
}

export function apiAuthResetUserPasswordPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthResetUserPasswordPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<ResetUserPasswordResponseDto>> {
    const rb = new RequestBuilder(rootUrl, apiAuthResetUserPasswordPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<ResetUserPasswordResponseDto>;
        }),
    );
}

apiAuthResetUserPasswordPost.PATH = '/api/auth/reset-user-password';
